export default __webpack_public_path__ + "static/media/logo.31e90c28.svg";